import { render, staticRenderFns } from "./CLessonBranch.vue?vue&type=template&id=d5f54c76"
import script from "./CLessonBranch.vue?vue&type=script&lang=js"
export * from "./CLessonBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5f54c76')) {
      api.createRecord('d5f54c76', component.options)
    } else {
      api.reload('d5f54c76', component.options)
    }
    module.hot.accept("./CLessonBranch.vue?vue&type=template&id=d5f54c76", function () {
      api.rerender('d5f54c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/CLessonBranch.vue"
export default component.exports